exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#appFooter[data-v-a6bbdd2c]{height:30px;line-height:30px;width:100%;color:#fff;text-align:center;position:fixed;bottom:0;z-index:999999\n}\n", "", {"version":3,"sources":["/opt/fh-web/firmiana-hpc-website-main/src/views/firmiana/home/footer.vue"],"names":[],"mappings":";AACA,4BAA4B,YAAY,iBAAiB,WAAW,WAAW,kBAAkB,eAAe,SAAS,cAAc;CACtI","file":"footer.vue","sourcesContent":["\n#appFooter[data-v-a6bbdd2c]{height:30px;line-height:30px;width:100%;color:#fff;text-align:center;position:fixed;bottom:0;z-index:999999\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a6bbdd2c","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/firmiana/home/footer.vue
// module id = pti1
// module chunks = 148